/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Duration_MinutesInputs */

const en_admin_resource_form_duration_minutes = /** @type {(inputs: Admin_Resource_Form_Duration_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration (minutes)`)
};

const de_admin_resource_form_duration_minutes = /** @type {(inputs: Admin_Resource_Form_Duration_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer (Minuten)`)
};

const es_admin_resource_form_duration_minutes = /** @type {(inputs: Admin_Resource_Form_Duration_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración (minutos)`)
};

const fr_admin_resource_form_duration_minutes = /** @type {(inputs: Admin_Resource_Form_Duration_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée (minutes)`)
};

/** @type {(inputs: Admin_Resource_Form_Duration_MinutesInputs) => LocalizedString} */
const it_admin_resource_form_duration_minutes = en_admin_resource_form_duration_minutes;

/** @type {(inputs: Admin_Resource_Form_Duration_MinutesInputs) => LocalizedString} */
const pt_br2_admin_resource_form_duration_minutes = en_admin_resource_form_duration_minutes;

/** @type {(inputs: Admin_Resource_Form_Duration_MinutesInputs) => LocalizedString} */
const pl_admin_resource_form_duration_minutes = en_admin_resource_form_duration_minutes;

/** @type {(inputs: Admin_Resource_Form_Duration_MinutesInputs) => LocalizedString} */
const hu_admin_resource_form_duration_minutes = en_admin_resource_form_duration_minutes;

/** @type {(inputs: Admin_Resource_Form_Duration_MinutesInputs) => LocalizedString} */
const ro_admin_resource_form_duration_minutes = en_admin_resource_form_duration_minutes;

/**
* | output |
* | --- |
* | "Duration (minutes)" |
*
* @param {Admin_Resource_Form_Duration_MinutesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_duration_minutes = /** @type {((inputs?: Admin_Resource_Form_Duration_MinutesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Duration_MinutesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_duration_minutes(inputs)
	if (locale === "de") return de_admin_resource_form_duration_minutes(inputs)
	if (locale === "es") return es_admin_resource_form_duration_minutes(inputs)
	if (locale === "fr") return fr_admin_resource_form_duration_minutes(inputs)
	if (locale === "it") return it_admin_resource_form_duration_minutes(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_duration_minutes(inputs)
	if (locale === "pl") return pl_admin_resource_form_duration_minutes(inputs)
	if (locale === "hu") return hu_admin_resource_form_duration_minutes(inputs)
	return ro_admin_resource_form_duration_minutes(inputs)
});
export { admin_resource_form_duration_minutes as "admin.resource_form.duration_minutes" }